import { Injectable } from '@angular/core';
import { LogService } from '../log/log.service';
import { DataPayloadI } from './types';

@Injectable({
  providedIn: 'root'
})
export class BenchmarkService {
  private _startTime: number;
  private _registeredRequestEvents = {};
  private _enableBenchmark = true;
  private _registeredEvents = {};

  constructor(private logService: LogService) {}

  public init(): void {
    this._startTime = window.performance.now();
  }

  public logPageLoad(label: string): void {
    if (!this._enableBenchmark) {
      return;
    }
    this.logService.info(`Benchmark :: ${label} page loaded`, this._getTimeDifference());
  }

  public registerPageEvent(type: string): void {
    this._registeredEvents[type] = {
      startTime: null
    };
    this._registeredEvents[type] = {
      startTime: window.performance.now()
    };
  }

  public logPageEventTime(label: string, type: string): void {
    if (!this._enableBenchmark || !this._registeredEvents[type]) {
      return;
    }
    const endTime = window.performance.now();
    const diffTime = endTime - this._registeredEvents[type].startTime;
    this.logService.info(`Benchmark :: ${label} page loaded`, `${diffTime.toFixed(2)}ms`);
  }

  public registerRequestEvent(data: DataPayloadI): void {
    if (!this._enableBenchmark) {
      return;
    }

    if (this._registeredRequestEvents[data.uid]) {
      this.logService.warn(`Benchmark :: data.uid ${data.uid} already exist.`);
    }

    this._registeredRequestEvents[data.uid] = {
      data,
      startTime: window.performance.now()
    };
  }

  public logRequestEvent(label: string, response: DataPayloadI): void {
    if (!this._enableBenchmark) {
      return;
    }

    if (!this._registeredRequestEvents[response.uid]) {
      this.logService.warn(`Benchmark :: uid event ${response.uid} was not set.`);
      return;
    }

    const endTime = window.performance.now();
    const diffTime = endTime - this._registeredRequestEvents[response.uid].startTime;

    this.logService.info(`Benchmark :: ${label} :: ${response.uid} :: ${diffTime} ms`, {
      request: this._registeredRequestEvents[response.uid],
      response: {
        data: response,
        endTime
      }
    });
  }

  private _getTimeDifference(): string {
    const diff = window.performance.now() - this._startTime;
    return `${diff.toFixed(2)}ms`;
  }
}
